import { useState } from "react";
import analytics from "@/utils/analytics";
import { useToast } from "@/hooks/use-toast";
import { useAPIOauthGoogleSession } from "@/hooks/use-api-oauth-google-session";

export const useGoogleAuth = () => {
  const [loading, setLoading] = useState(false);
  const { handleAPIOauthGoogleSession } = useAPIOauthGoogleSession();
  const { showToastByCode } = useToast();
  
  const googleAuth = async (agentId?: string) => {
    analytics.trackGoogleLogin();
    setLoading(true);
    try {
      const { oauthUrl } = await handleAPIOauthGoogleSession(`${window.location.protocol}//${window.location.host}/login/`, agentId);
      window.location.href = oauthUrl;
    } catch (error) {
      analytics.trackGoogleLoginFail({ reason: error.message });
      setLoading(false);
      showToastByCode(error);
    }
  };

  return {
    googleAuth,
    loading,
  }
};
